import request from '@/utils/request'

export function getMomentList(params) {
  return request({
    url: '/admin/moment/list',
    method: 'get',
    params
  })
}

export function getMomentDetail(id) {
  return request({
    url: '/admin/moment/' + id,
    method: 'get'
  })
}

export function updateMoment(data) {
  return request({
    url: '/admin/moment',
    method: 'put',
    data
  })
}

export function deleteMoment(id) {
  return request({
    url: '/admin/moment/' + id,
    method: 'delete'
  })
}

export function getComments(momentId, params) {
  return request({
    url: '/admin/moment/' + momentId + '/comments',
    method: 'get',
    params
  })
}

export function deleteComment(momentId, commentId) {
  return request({
    url: '/admin/moment/' + momentId + '/comment/' + commentId,
    method: 'delete'
  })
}

/**
 * 运营置顶
 * @param {number} id 动态 ID
 * @param {object} data { pinScope: 'SCHOOL'|'CITY', durationHours: number|null }，durationHours 为空表示永久
 */
export function pinMoment(id, data) {
  return request({
    url: '/admin/moment/' + id + '/pin',
    method: 'put',
    data: data || {}
  })
}

export function unpinMoment(id) {
  return request({
    url: '/admin/moment/' + id + '/unpin',
    method: 'put'
  })
}
